import { Grid, } from '@material-ui/core';
import moment from 'moment';

import { TemplateMultiList } from "../../../atomic/templates/TemplateMultiList";
import { useTotem } from '../../../../hooks/useCases/useTotem';

export const SolicitudesRecepcionista = () => {
    const totem  = useTotem();
    
    const recepciones = totem.data.recepciones.filter((item) => 
      !totem.data.solicitudesRecepcionesUsuario.some(s => s.idRecepcion === item.id) &&
      !totem.data.recepcionesUsuario.some(ru => ru.id === item.id)
    );
    const solicitudesPendientes = totem.data.solicitudesRecepcionesUsuario;
    const recepcionesUsuario = totem.data.recepcionesUsuario;
  
    return (
      <Grid item xs={10} style={{margin: "auto"}}>
        <TemplateMultiList 
          templateLists={[
            {
              checkBox: {
                text: "Solicitar",
                onClick: (selected, setSelected) => { 
                  totem.insert.solicitudesRecepcionesUsuario({ recepciones: selected.join(',') });
                  setSelected([]);
                }
              },
              title: "Solicitar Recepción",
              list: recepciones,
              columns: [
                {
                  label: "Recepciones",
                  id: "descripcion"
                }
              ]
            },
            {
              checkBox: {
                text: "Eliminar",
                onClick: (selected, setSelected) => { 
                  totem.remove.solicitudesRecepcionesUsuario({ solicitudes: selected.join(',') }, selected);
                  setSelected([]);
                }
              },
              title: "Solicitudes Pendientes",
              list: solicitudesPendientes,
              columns: [
                {
                  label: "Recepciones",
                  id: "recepcion.descripcion"
                },
                {
                  label: "Fecha Solicitud",
                  customBody: (item) => moment(item.fechaSolicitud).format("DD/MM/YYYY - HH:mm")
                }
              ]
            },
            {
              title: "Recepciones Confirmadas",
              list: recepcionesUsuario,
              columns: [
                {
                  label: "Recepciones",
                  id: "descripcion"
                }
              ]
            }
          ]}
        />
      </Grid>
    )
}